import React, { Fragment } from "react";
import { Row, Col, Container, Card, Collapse } from "reactstrap";

export default function GridView(props) {

  // Inline CSS as a string
  const gridViewStyles = `
    .card-tile {
      position: relative;
      padding: 15px;
      min-height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      border: 1px solid #ccc;
      border-radius: 6px;
    }
    .card-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }
    .card-text {
      flex: 1;
      margin-right: 10px;
      word-break: break-word; /* wrap long text */
      cursor: pointer;
      text-align: left;
    }
    .card-actions {
      flex-shrink: 0;
      cursor: pointer;
      color:  #fff;;
    }
    .card-actions i:hover {
      color:  #fff;;
    }
    .add-card {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 24px;
      cursor: pointer;
      color: #007bff;
    }
  `;

  return (
    <Fragment>
      {/* Inject inline CSS */}
      <style>{gridViewStyles}</style>

      <Container>
        <Row className="admin-settings py-3">
          <Col sm={12}>
            <Collapse isOpen={props.isOpenGridView}>
              <Row>
                {/* Add New Card */}
                <Col lg={3} md={6} sm={6} xs={12} className="mb-3">
                  <Card
                    body
                    inverse
                    className="card-tile add-card"
                    onClick={() => {
                      props.emptyFormField();
                      props.toggle();
                      props.reset();
                    }}
                  >
                    <i className="fas fa-plus text-center"></i>
                  </Card>
                </Col>

                {/* Existing Questions */}
                {Array.from(props.pagaData).map((val, i) => (
                  <Col
                    lg={props.displayData.heading === "question" ? 6 : 3}
                    md={6}
                    sm={6}
                    xs={12}
                    className="mb-3"
                    key={i}
                  >
                    <Card body inverse className="card-tile">
                      <div className="card-content">
                        {/* Question Text */}
                        <span
                          className="card-text"
                          onClick={() => {
                            props.handleSelectedDesg(val, i);
                            props.toggle();
                          }}
                        >
                          {val[props.displayData.heading]}
                        </span>

                        {/* Delete Icon */}
                        <div
                          className="card-actions"
                          onClick={() =>
                            props.handleDel(val[props.displayData.id])
                          }
                        >
                          <i className="fas fa-times"></i>
                        </div>
                      </div>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Collapse>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}